import { render, staticRenderFns } from "./ContactForm.vue?vue&type=template&id=0187bd91&scoped=true"
import script from "./ContactForm.ts?vue&type=script&lang=ts&external"
export * from "./ContactForm.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0187bd91",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0187bd91')) {
      api.createRecord('0187bd91', component.options)
    } else {
      api.reload('0187bd91', component.options)
    }
    module.hot.accept("./ContactForm.vue?vue&type=template&id=0187bd91&scoped=true", function () {
      api.rerender('0187bd91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/ProcessesForms/components/P48/ContactForm/ContactForm.vue"
export default component.exports